import { once } from './_loader.js';
// HIDE TITLE ON OVER

// LINKS

let img_title;

$('img').on("mouseenter", function disableTitle(element) {
    img_title = $(this).attr("title");
    $(this).attr("title", '');
}).on("mouseleave", function enableTitle(element) {
    $(this).attr("title", img_title);
});


let href_title;

$('a').on("mouseenter", function disableATitle(element) {
    href_title = $(this).attr("title");
    $(this).attr("title", '');
}).on("mouseleave", function enableATitle(element) {
    $(this).attr("title", href_title);
});


// EMAILS
export function decode_emails() {
    if ($('a[href*="{at}"]').length > 0) {
      console.log("decode_emails");
      $('a[href*="{at}"]').each(function trigger_decode_mail() {
        var my_link = $(this).attr("href");
        var my_text = $(this).html();
        var new_link = my_link.replace("{at}", "@");
        var new_text = my_text.replace("{at}", "@");
        $(this).attr("href", new_link);
        $(this).html(new_text);
      });
    }
  }


  // LAZY VIDEOS

  // // LAZY VIDEOS LOADING

function load_lazy_video_autoplay(lazyFile) {

  if (lazyFile.dataset.src) {
      lazyFile.src = lazyFile.dataset.src;

      lazyFile.load();

      if (lazyFile.classList.contains("lazy_video_autoplay")) {
          lazyFile.addEventListener('canplay', function canplaythroughlistener() {
              lazyFile.play();
          }, once);
          lazyFile.addEventListener('error', function canplaythrougherror(error) {
              console.log(error);
          }, once);
      }

  } 
}


// LAZY VIDEOS

// INTERSECTION OBSERVER FOR LAZY VIDEOS
document.addEventListener("DOMContentLoaded", function () {

  var lazyFiles = [].slice.call(document.querySelectorAll(".lazy"));

  if ("IntersectionObserver" in window) {

      let lazyFileObserver = new IntersectionObserver(function newIntersectionObserver(entries, observer) {
          entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                  let lazyFile = entry.target;
                  if (lazyFile.classList.contains("lazy_video")) {
                      load_lazy_video_autoplay(lazyFile);
                      lazyFile.classList.remove("lazy");
                  }
                  lazyFileObserver.unobserve(lazyFile);
              }
          });
      });

      lazyFiles.forEach(function (lazyFile) {
          lazyFileObserver.observe(lazyFile);
      });

  } else {
      // Possibly fall back to event handlers here
      $('.lazy_video').each(function lazyloadfallbar(idx) {
          let lazyFile = $(this);
          lazyFile.src = lazyFile.dataset.src;
          lazyFile.classList.remove("lazy");
      });

  }
});


// var mouseenter_timeout;

// if(navigator.userAgent.indexOf("Chrome") != -1) {

// $('.button').on("mouseenter", function play_audio_on_hover(){

//     console.log("mouseenter button");

//     $('#sound_on_hover')[0].pause();
//     $('#sound_on_hover')[0].currentTime = 0;
//     $('#sound_on_hover')[0].play();

// });

// $('.menu-item').on("mouseenter", function play_nav_audio_on_hover() {
    
//     console.log("mouseenter .menu-item");
//     let  my_id = $(this).attr("id");
//     console.log("mouseenter "+ my_id );

//     if( $('#'+my_id+'-audio').length > 0) {
//         console.log('my_id-'+my_id+' found');
//         let my_audio = $('#'+my_id+'-audio');
//         my_audio[0].pause();
//         my_audio[0].currentTime = 0;
//         my_audio[0].play();
//     } else {
//         console.log('#'+my_id+'-audio not found');
//     }
// });


// $('body').on("click", function unmute_audio(){

//     $('audio').each(function unmute_audios(idx) {

//         if($(this)[0].muted == true) {
//             $(this)[0].pause();
//             $(this)[0].muted = false;
//         } else {
//             console.log("audio"+ idx + " already unmuted");
//         }

//     });

// });

// }